import {AppState} from "../store";

export const getTicketPageFilter = (state: AppState) => state.ticketPage.filter
export const getTicketPageState = (state: AppState) => state.ticketPage.state
